import $ from "jquery";
import Scrolling from "./Scrolling";

export default {

    init: (uniqID) => {

        let isJobOffersArchive = $('.js-jobofferslides').length > 0;
        let hash = location.hash.replace('#','');
        let lastPos = 0;

        $("[data-accordion] .head").on("click", function (event) {
            event.preventDefault();

            if ($(this).parent().hasClass("open")) {
                $(this).parent().find(".body").slideUp(300);
                $(this).parent().removeClass("open");

                if (isJobOffersArchive && undefined != $(this).data('anchor')) {
                    lastPos = $(window).scrollTop();
                    location.hash = '';
                }
            } else {
                $(this).parent().parent().find(".body").slideUp(300);
                $(this).parent().parent().find("li").removeClass("open");


                $(this).parent().addClass("open");

                $(this).parent().find(".body").slideDown(300);

                if (isJobOffersArchive) {
                    location.hash = '';

                    if (undefined != $(this).data('anchor')) {
                        lastPos = $(window).scrollTop();
                        location.hash = $(this).data('anchor');
                    }
                }

/*                setTimeout(function () {
                    Scrolling.scrollTo('[data-accordion]#' + uniqID + ' .open', 'easeInOutQuint', 800, 0);
                }, 300);*/
            }

        });

        if (isJobOffersArchive) {

        }
        $(window).bind('hashchange', function() {
            hash = location.hash.replace('#','');
            if (hash == '') {
                $(window).scrollTop(lastPos);
            }
        });

        if (hash != '') {
            $("[data-accordion] .head").each(function() {
                if ($(this).data('anchor') == hash) {
                    $(this).trigger('click');
                }
            });
        }

    },

    destroy() {
        $("[data-accordion] .head").off("click");
    }


};